import { Component } from '@angular/core';
import { ErrorMessages } from '../../../errormessages';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss'
})
export class UnauthorizedComponent {
  AccessDenied = ErrorMessages.AccessDenied;
}
